module.exports = __webpack_public_path__ + "static/media/thevrara.f9c8a888.png";